import React from 'react';
import ReactDOM from 'react-dom';
import { routes } from 'routes';
import { configs } from './configs';
// import 'babel-polyfill';
import injectTapEventPlugin from 'react-tap-event-plugin';

injectTapEventPlugin();

function runApp() {
  ReactDOM.render(routes, document.getElementById('content'));
}

if (!window.Intl) {

  //('hello again, safari');
  // __webpack_public_path__ = configs.scrollingUrl + '/dist/';

  require.ensure(['intl'], (require) => {
    //TODO: So need to figure out how to include the translations here, which should pull them in ad-hoc?
    window.Intl = require('intl');

    require('intl/locale-data/jsonp/en.js');
    runApp();
  }, 'intl-polyfill');
} else {
  runApp();
}



// WEBPACK FOOTER //
// ./client.js